import React from 'react';
import Dashboard from '../components/Dashboard';
import usePageMeta from '../hooks/usePageMeta';

function DashboardPage() {
  usePageMeta({
    title: 'Dashboard',
    noindex: true,
  });

  return <Dashboard />;
}

export default DashboardPage;
